<template>
  <div class="ultra-t1-wrap">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <section class="ultra-t1-banner" :class="isMobile ? '' : 'fill-section-1080'">
      <img class="img-cover" :src="`${imgUrlPrefix}${mainBanner}`" alt="ultra-t1" @load="pageLoad" @error="pageLoad"/>
      <div class="ultra-t1-banner-content">
        <img class="hanwei-logo" :src="`${imgUrlPrefix}sec1_logo.png`" alt="HANWEI MOTORSPORT" />

        <h3 class="fade-up" v-html="bannerTitle"></h3>

        <p class="fade-up" v-html="bannerDesc"></p>
        <a href="javascript:;" class="btn fade-up">立即预约 →</a>
      </div>
    </section>

    <!-- 图片+视频+文字组合 -->
    <section class="ultra-t1-sec2">
      <div class="ultra-t1-sec2-box">
        <!-- pc:3列布局, 移动端1列 -->
        <div class="ultra-t1-sec2-col">
          <div class="ultra-t1-sec2-col-1 ultra-t1-sec2-item" v-for="(item, index) in sec2List.slice(0, 2)" :key="'col-1' + index">
            <img class="ultra-t1-sec2-pic lazy-img" v-if="item.type === 'image'" :src="item.src + '.jpg'" alt="">
            <video class="ultra-t1-sec2-video" v-if="item.type === 'video'" :src="item.src + '.mp4'" autoplay muted loop playsinline ></video>
            <div class="ultra-t1-sec2-overlay"></div>
            <div class="ultra-t1-sec2-content">
              <img class="ultra-t1-sec2-icon lazy-img" :src="item.icon + '.png'" alt="" />
              <div class="ultra-t1-sec2-tag fade-up">{{item.tag}}</div>
              <div class="ultra-t1-sec2-name fade-up">{{item.name}}</div>
              <div class="ultra-t1-sec2-desc fade-up" v-html="item.desc"></div>
            </div>
          </div>
        </div>
        <div class="ultra-t1-sec2-col">
          <div class="ultra-t1-sec2-col-2 ultra-t1-sec2-item" v-for="(item, index) in sec2List.slice(2,3)" :key="'col-2' + index">
            <img class="ultra-t1-sec2-pic lazy-img" v-if="item.type === 'image'" :src="item.src + '.jpg'" alt="">
            <video class="ultra-t1-sec2-video" v-if="item.type === 'video'" :src="item.src + '.mp4'" autoplay muted loop playsinline ></video>
            <div class="ultra-t1-sec2-overlay"></div>
            <div class="ultra-t1-sec2-content">
              <img class="ultra-t1-sec2-icon lazy-img" :src="item.icon + '.png'" alt="" />
              <div class="ultra-t1-sec2-tag fade-up">{{item.tag}}</div>
              <div class="ultra-t1-sec2-name fade-up">{{item.name}}</div>
              <div class="ultra-t1-sec2-desc fade-up" v-html="item.desc"></div>
            </div>
          </div>
        </div>
        <div class="ultra-t1-sec2-col">
          <div class="ultra-t1-sec2-col-3 ultra-t1-sec2-item" v-for="(item, index) in sec2List.slice(3, 6)" :key="'col-3' + index">
            <img class="ultra-t1-sec2-pic lazy-img" v-if="item.type === 'image'" :src="item.src + '.jpg'" alt="">
            <video class="ultra-t1-sec2-video" v-if="item.type === 'video'" :src="item.src + '.mp4'" autoplay muted loop playsinline ></video>
            <div class="ultra-t1-sec2-overlay"></div>
            <div class="ultra-t1-sec2-content">
              <img class="ultra-t1-sec2-icon lazy-img" :src="item.icon + '.png'" alt="" />
              <div class="ultra-t1-sec2-tag fade-up">{{item.tag}}</div>
              <div class="ultra-t1-sec2-name fade-up">{{item.name}}</div>
              <div class="ultra-t1-sec2-desc fade-up" v-html="item.desc"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 车辆参数 -->
    <section class="ultra-t1-sec3" :class="isMobile ? '' : 'fill-section-1080'">
      <img class="img-cover lazy-img" :src="`${imgUrlPrefix}${ isMobile ? 'm-sec3_1.jpg' : 'sec3_1.jpg' }`" alt="" />
      <div class="ultra-t1-sec3-content">
        <h5 class="fade-up">METTA RACING<br>越野挑战赛</h5>
        <p class="fade-up">穿越巴丹吉林沙漠T3超级赛道<br>真实赛段，实时计时<br>线上报名，线下出发，全国积分排名</p>
      </div>
      <div class="ultra-t1-sec3-list">
        <div class="ultra-t1-sec3-item" v-for="(item, index) in sec3List" :key="index">
          <h5 class="fade-up">{{ item.name }}</h5>
          <p class="fade-up" v-html="item.desc"></p>
        </div>
      </div>
    </section>

    <section v-if="isMobile">
      <img class="img-cover lazy-img" :src="`${imgUrlPrefix}m-sec5_1.jpg`" alt="" />
    </section>
    <section v-else class="ultra-t1-sec5">
      <img class="img-cover lazy-img" :src="`${imgUrlPrefix}sec5_1.jpg`" alt="" />
    </section>

    <section class="ultra-t1-sec6" :class="isMobile ? '' : 'fill-section-1080'">
      <img class="img-cover lazy-img" :src="`${imgUrlPrefix}${ isMobile ? 'm-sec6_1.jpg' : 'sec6_1.jpg' }`" alt="" />
      <h5><span>HWM T1+</span>PARTNERS<br>合作伙伴</h5>
    </section>

    <section class="ultra-t1-sec7" :class="isMobile ? '' : 'fill-section-1080'">
      <img class="img-cover lazy-img" :src="`${imgUrlPrefix}${ isMobile ? 'm-sec7_1.jpg' : 'sec7_1.jpg' }`" alt="" />
      <div class="ultra-t1-sec7-box">
        <div class="ultra-t1-sec7-txt fade-up" v-html="sec7Title"></div>
        <p class="ultra-t1-sec7-txt2 fade-up">与韩魏一起<br>
集结车企、车手、行业伙伴与广大车迷<br>
以纯国产自研为核心，深耕达喀尔顶级赛事技术<br>
融合赛事经验、硬核技术与大众创意<br>
攻坚动力、底盘、车身全链条研发<br>
打磨国产顶级越野赛车</p>
        <div class="ultra-t1-sec7-btns">
          <button class="btn-a fade-up">立即预约 →</button>
          <button class="btn-b fade-up" @click="$router.push({ path: '/', query: { scrollTo: 'car-series' } })">进入载具库</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import { checkIsMobile } from '../utils/tools.js'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
import { imgLazyLoad, destroyImgLazyLoad } from '../utils/imgLazyLoad'
import { videoObserverByClass, destroyVideoObserverByClass } from '../utils/videoPlayObserver.js'
export default {
  components: {
    Loading,
  },

  mounted() {
    this.$nextTick(() => {
      videoObserverByClass('ultra-t1-sec2-video');
      fadeAnimate();
      imgLazyLoad();
    });
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    destroyFadeAnimate();
    destroyImgLazyLoad();
    destroyVideoObserverByClass();
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    bannerTitle() {

      return this.isMobile

        ? '专为达喀尔<br>T1+组别<br>打造'

        : '专为达喀尔<br>T1+组别打造'

    },

    bannerDesc() {

      return this.isMobile

        ? '碳纤维车身，LS3 V8 引擎<br>极致越野性能'

        : '碳纤维车身，LS3 V8 引擎极致越野性能'

    },
    mainBanner() {
      return this.isMobile ? 'm-sec1_1.jpg' : 'sec1_1.jpg'
    },
    sec7Title() {
      return this.isMobile ? '国民T1+<br>赛车共创计划' : '国民T1+赛车共创计划'
    },
  },
  data() {
    const imgUrlPrefix = '/assets/images/ultraT1/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      // 图片+视频+文字组合数据
      sec2List: [
        {
          icon: imgUrlPrefix + 'sec2_icon_1',
          tag: 'Powertrain （动力总成）',
          name: '505 HP',
          desc: 'L53 525 V8 6.2L<br>600 N.m Torque 最大扭矩<br>6-speed auto 自动6速',
          type: 'video',
          src: imgUrlPrefix + 'sec2_video_1'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_2',
          tag: 'Structure（结构）',
          name: '2010 KG',
          desc: 'Cage frame 笼架式<br>Carbon fiber +fiberglass 碳纤维+玻璃钢<br>4400x2280x1890mm Dimensions 长*宽*高',
          type: 'video',
          src: imgUrlPrefix + 'sec2_video_2'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_3',
          tag: 'Suspension（悬架）',
          name: 'HWM',
          desc: ' single/double-adjustable coilover （front/rear）<br>单/双绞牙减震器独立悬挂（前后）<br>390mm Ground Clearance 离地间隙',
          type: 'video',
          src: imgUrlPrefix + 'sec2_video_3'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_4',
          tag: 'Performance（性能） ',
          name: '180 KM/H',
          desc: 'Top Speed 最高车速<br>480L Fuel Tank 油箱容量',
          type: 'video',
          src: imgUrlPrefix + 'sec2_video_4'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_5',
          tag: 'DRIVETRAIN（整车驱动系统）',
          name: '4WD SYSTEM',
          desc: 'Front / Center / Rear Differential<br>Optimized for Rally Raid Terrain<br>前/中/后差速器针对越野地形优化',
          type: 'video',
          src: imgUrlPrefix + 'sec2_video_5'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_6',
          tag: 'RELIABILITY（可靠性/耐久） ',
          name: 'DAKAR READY ',
          desc: 'Long-Distance Endurance Design<br>Marathon Stage Proven<br>长距离耐力设计经马拉松赛段验证',
          type: 'video',
          src: imgUrlPrefix + 'sec2_video_6'
        },
      ],
      // 车辆参数数据
      sec3List: [
        { name: 'CHASSIS', desc: 'Cage frame<br>高强度笼架式车架' },
        { name: 'TIRES', desc: 'SAILUN 37" 赛版轮胎<br>+17" inner beadlock<br>防脱圈轮毂' },
        { name: 'BRAKES', desc: 'HWM 前后制动系统' },
        { name: 'DRIVE', desc: 'Mid-mounted<br>4WD中置四驱 + Torsen/<br>LSD差速器' },
        { name: 'SYSTEM', desc: 'HOLLEY赛车电脑<br>管理系统' },
      ],
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    pageLoad() {
      this.isLoading = false
    }
  },
}
</script>

<style lang="less" scoped>
.ultra-t1-wrap {
  width: 100%;
  font-weight: @fw2;
  font-family: 'TsangerYunHei', sans-serif;
  .ultra-t1-banner {
    position: relative;
    .ultra-t1-banner-content {
      position: absolute;

      left: 7.8vw;

      top: 4.8vw;

      z-index: 2;

      img,

      .hanwei-logo {

        width: 8.5vw;

        height: auto;

      }

      h3 {

        font-weight: @fw1;

        color: #000;

        font-size: clamp(48px, 4.38vw, 84px);

        margin-top: 1.2vw;

        line-height: 1.2;

      }

      p {

        font-weight: @fw2;

        color: #000;

        font-size: clamp(16px, 1.3vw, 24px);

        margin-top: 1.2vw;

        letter-spacing: 0.12em;

      }

      .btn {

        display: none;

      }
    }
  }
  .ultra-t1-sec2 {
    min-width: 1200px;
    padding: 9.07vw 5.67vw 11.17vw;
    background-image: url('/assets/images/ultraT1/sec2_bg.jpg');
    .ultra-t1-sec2-box {
      width: 100%;
      margin: 0 auto;
      display: flex;
      aspect-ratio: 1720 / 1285; // 保持宽高比
      height: auto;
      .ultra-t1-sec2-col {
        display: flex;
        flex-direction: column;
        flex: 1;

        .ultra-t1-sec2-item {
          position: relative;
          overflow: hidden;
          .ultra-t1-sec2-overlay {
            position: absolute;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .ultra-t1-sec2-content {
            position: absolute;
            inset: 1.95vw;
            font-weight: @fw2;
            .ultra-t1-sec2-icon {
              width: 4.88vw;
              height: 4.88vw;
            }
            .ultra-t1-sec2-tag {
              margin-top: 0.78vw;
              color: #fff;
              font-size: clamp(12px, 0.83vw, 16px);
              text-transform: uppercase;
            }
            .ultra-t1-sec2-name {
              margin-top: 0.78vw;
              color: #C8FC00;
              font-size: clamp(32px, 2.5vw, 48px);
            }
            .ultra-t1-sec2-desc {
              margin-top: 0.78vw;
              color: rgba(255, 255, 255, 0.7);
              font-size: clamp(16px, 1.25vw, 24px);
            }
          }
          .ultra-t1-sec2-pic {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .ultra-t1-sec2-video {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .ultra-t1-sec2-col-1 {
          height: 50%;
        }
        .ultra-t1-sec2-col-2 {
          height: 100%;
        }
        .ultra-t1-sec2-col-3 {
          flex: 1;
        }
      }
    }
  }
  .ultra-t1-sec3 {
    min-width: 1200px;
    .ultra-t1-sec3-content {
      position: absolute;
      left: 4.88vw;
      top: 4.88vw;
      font-weight: @fw2;
      color: rgba(255, 255, 255, 0.7);
      width: 27.2vw;
      span {
         font-size: clamp(12px, 0.83vw, 16px);
      }
      h5 {
        color: #fff;
        font-weight: @fw1;
        font-size: clamp(32px, 2.5vw, 48px);
        margin: 0.78vw auto;
      }
      p {
        font-size: clamp(16px, 1.25vw, 24px);
        margin-bottom: 1.67vw;
      }
    }
    .ultra-t1-sec3-list {
      display: flex;
      justify-content: space-evenly;
      position: absolute;
      left: 0;
      bottom: 4.88vw;
      width: 100%;
      .ultra-t1-sec3-item {
        font-weight: @fw2;
        text-align: center;
        h5 {
          color: #D1FF07;
          font-size: clamp(46px, 3.33vw, 64px);
          font-weight: @fw1;
        }
        p {
          color: #fff;
          font-size: clamp(16px, 1.25vw, 24px);
        }
      }
    }
  }
  .ultra-t1-sec5 {
    width: 100%;
    aspect-ratio: 1920 / 953;
  }
  .ultra-t1-sec6 {
    position: relative;
    h5 {
      position: absolute;
      text-align: center;
      left: 0;
      top: 6.25vw;
      color: #fff;
      font-size: clamp(32px, 2.5vw, 48px);
      width: 100%;
      font-family: 'TsangerYunHei', sans-serif;
      font-weight: @fw1;
      line-height: 1.2;
      span {
        color: #D1FF07;
      }
    }
  }
  .ultra-t1-sec7-box {
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-weight: @fw2;
    text-align: center;
    .ultra-t1-sec7-txt {
      color: #fff;
      font-size: clamp(32px, 2.5vw, 48px);
      line-height: 1.2;
      text-transform: uppercase;
      span {
        color: #D1FF07;
      }
    }
    .ultra-t1-sec7-txt2 {
      margin-top: 1.67vw;
      font-size: clamp(16px, 1.25vw, 24px);
      color: #fff;
    }
    .ultra-t1-sec7-btns {
      margin-top: 1.46vw;
      display: flex;
      justify-content: center;
      gap: 16px;
      button {
        width: 130px;
        height: 40px;
        &.btn-a {
          background-color: #D1FF07;
          color: #231E1E;
        }
        &.btn-b {
          background-color: transparent;
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.4);
        }
      }
    }
  }
}
@media (max-width: @mobile-width) {
  .ultra-t1-wrap {
    .ultra-t1-banner {
      .ultra-t1-banner-content {
        position: absolute;
        left: 5.33vw;
        right: 10.67vw;
        top: 33.33vw;
        .hanwei-logo {

          width: 25vw; 

        }
        img {
          width: 79.2vw;
          height: auto;
        }
        h3 {
          font-size: 12.8vw;
          margin-top: 1.1vw;
        }
        p {
          font-size: 6.4vw;
          margin-top: 3.2vw;
        }
        .btn {
          width: fit-content;
          font-size: 4.26vw;
          padding: 2.67vw 5.33vw;
          margin-top: 5.87vw;
        }
      }
    }
    .ultra-t1-sec2 {
      width: 100%;
      padding: 9.6vw 5.33vw ;
      background-image: url('/assets/images/ultraT1/sec2_bg.jpg');
      background-size: cover;
      background-position: left center;
      .ultra-t1-sec2-box {
        width: auto;
        display: flex;
        aspect-ratio: auto;
        height: auto;
        flex-direction: column;
        .ultra-t1-sec2-col {
          display: flex;
          flex-direction: column;
          flex: none;
          width: 89.33vw;
          row-gap: 5.33vw;
          .ultra-t1-sec2-item {
            position: relative;
            overflow: hidden;
            width: 89.33vw;
            height: 65.87vw;
            .ultra-t1-sec2-content {
              position: absolute;
              inset: 3.47vw;
              font-weight: @fw2;
              .ultra-t1-sec2-icon {
                width: 15.47vw;
                height: 15.47vw;
              }
              .ultra-t1-sec2-tag {
                margin-top: 2.4vw;
                font-size: 2.4vw;
              }
              .ultra-t1-sec2-name {
                margin-top: 2.4vw;
                color: #C8FC00;
                font-size: 7.47vw;
              }
              .ultra-t1-sec2-desc {
                margin-top: 2.4vw;
                font-size: 3.73vw;
              }
            }
            .ultra-t1-sec2-pic {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .ultra-t1-sec2-video {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .ultra-t1-sec2-col-1 {
            height: 65.87vw;
          }
          .ultra-t1-sec2-col-2 {
            height: 65.87vw;
            margin: 5.33vw 0;
          }
          .ultra-t1-sec2-col-3 {
            flex: none;
            height: 65.87vw;
          }
        }
      }
    }
    .ultra-t1-sec3 {
      min-width: auto;
      width: 100%;
      position: relative;
      .ultra-t1-sec3-content {
        position: absolute;
        left: 5.33vw;
        right: 5.33vw;
        top: 21.33vw;
        width: auto;
        text-align: center;
        span {
          font-size: 4.26vw;
          text-transform: uppercase;
          letter-spacing: 1.07vw;
        }
        h5 {
          color: #fff;
          font-size: 8.53vw;
          margin: 1.6vw auto;
        }
        p {
          font-size: 4.26vw;
          margin-bottom: 5.33vw;
        }
      }
      .ultra-t1-sec3-list {
        display: flex;
        justify-content: flex-start;
        position: absolute;
        left: 0;
        bottom: 15.47vw;
        flex-wrap: wrap;
        .ultra-t1-sec3-item {
          width: 50%;
          h5 {
            font-size: 8.53vw;
          }
          p {
            font-size: 4.26vw;
            line-height: 1.2;
          }
        }
      }
    }
    .ultra-t1-sec6 {
      h5 {
        top: 21.33vw;
        font-size: 8.53vw;
      }
    }
    .ultra-t1-sec7 {
      position: relative;
      .ultra-t1-sec7-box {
        .ultra-t1-sec7-txt {
          font-size: 8.53vw;
          line-height: 1.2;
          span {
            color: #D1FF07;
          }
        }
        .ultra-t1-sec7-txt2 {
          margin-top: 1.6vw;
          font-size: 4.26vw;
        }
        .ultra-t1-sec7-btns {
          margin-top: 5.33vw;
          gap: 4.26vw;
          button {
            width: 34.67vw;
            height: 10.67vw;
            font-size: 4.26vw;
            &.btn-a {
              background-color: #D1FF07;
              color: #231E1E;
            }
            &.btn-b {
              background-color: transparent;
              color: #fff;
              border: 1px solid rgba(255, 255, 255, 0.4);
            }
          }
        }
      }
    }
  }
}
</style>